"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Renders the Selected icon
 * @param {React.SVGProps<SVGSVGElement>} props - The props for the Selected component
 * @returns {JSX.Element} - The Selected component
 * @example
 * <Selected />
 * @example
 * <Selected height={24} width={24} />
 * @example
 * <Selected className="custom-class" />
 */
function Selected({ isDecorative, ...props }) {
    return (react_1.default.createElement("svg", { width: "18", height: "14", viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        react_1.default.createElement("path", { d: "M5.80004 10.78L2.30004 7.28002C1.91004 6.89002 1.29004 6.89002 0.900044 7.28002C0.510044 7.67002 0.510044 8.29002 0.900044 8.68002L5.09004 12.87C5.48004 13.26 6.11004 13.26 6.50004 12.87L17.1 2.28002C17.49 1.89002 17.49 1.27002 17.1 0.880024C16.71 0.490024 16.09 0.490024 15.7 0.880024L5.80004 10.78Z", fill: "#044985" }),
        !isDecorative && react_1.default.createElement("title", null, "selected icon")));
}
exports.default = Selected;
